import { token } from "functions/Helper";
import AgentBookingPendingList from "views/AgentBooking/PendingList";
import AgentBookingSubmittedList from "views/AgentBooking/SubmittedList";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AgentBookingDetail from "views/AgentBooking/Detail";
import AgentBookingAddNotes from "views/AgentBooking/AddNotes";

const agentBooking = () => {
  let views = [];

  if (
    token["booking.agent_bookings.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views = [
      {
        path: "/AgentBooking/Pending",
        name: "Pending",
        mini: "PE",
        component: AgentBookingPendingList,
        layout: "/admin"
      },
      {
        path: "/AgentBooking/Submitted",
        name: "Submitted",
        mini: "SU",
        component: AgentBookingSubmittedList,
        layout: "/admin"
      }
    ];

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Agent Booking",
        icon: MonetizationOnIcon,
        state: "AgentBookingCollapse",
        views: views
      }
    ];
  return [];
};

const agentBookingHidden = () => {
  let views = [];
  if (
    token["booking.agent_bookings.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/AgentBooking/Detail",
      name: "View Online Booking",
      component: AgentBookingDetail,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });

  if (
    token.is_admin === "True" ||
    token["booking.agent_booking_notes.write"] === "allowed"
  )
    views.push({
      path: "/AgentBooking/AddNotes",
      name: "Add Note Online Booking",
      component: AgentBookingAddNotes,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Agent Booking Hidden",
        state: "agentBookingHidden",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};

export { agentBooking, agentBookingHidden };
